import { useUIConfiguration } from "@/contexts/UIConfiguration";
import { useAPI } from "@/services/api";
import { captureEvent } from "@Light/app/analytics";
import { getFingerprint } from "@Light/app/fingerprint";
import { useOptionalOptOutSurvey } from "@Light/components/optOutSurvey";
import { useEffect } from "react";
import { closeParent } from "./messages";

export const useLogout = (source?: string) => {
  const { useLogoutMutation } = useAPI();
  const [logout, logoutState] = useLogoutMutation();
  const { hideCloseButton } = useUIConfiguration();
  const optOutSurvey = useOptionalOptOutSurvey();

  const { useGetConfigurationQuery } = useAPI();
  const configuration = useGetConfigurationQuery(getFingerprint());

  const appUrl = configuration.data?.app_url;

  const onClick = (inlineSource?: string, force = false) => {
    // When opt-out survey is active and not forced, let the survey handle the flow.
    // User may click "Return to plan" (no logout) or confirm exit (calls back with force=true).
    if (optOutSurvey && !force) {
      optOutSurvey.requestClose(inlineSource ?? source);
      return;
    }

    captureEvent("flow_logout", {
      logout_source: inlineSource ?? source ?? "other",
    });

    // Redirect to app URL if close button is hidden (embedded iframe scenario)
    if (hideCloseButton && appUrl && window.top) {
      window.top.location.href = appUrl ?? "";
      return;
    }

    logout();
  };
  useEffect(() => {
    if (logoutState.isSuccess || logoutState.isError) {
      closeParent();
    }
  }, [logoutState]);

  return onClick;
};
